import React, { createContext, useContext } from 'react';
import * as frac_api from '../api/FracApi.ts';

interface Dependencies {
  fracAPI: frac_api.FracApi;
}


const DependenciesContext = createContext<Dependencies | undefined>(undefined);

interface DependenciesProviderProps {
  children: React.ReactNode;
  dependencies: Dependencies;
}

export const DependenciesProvider: React.FC<DependenciesProviderProps> = ({ children, dependencies }) => {
  return (
    <DependenciesContext.Provider value={dependencies} >
      {children}
    </DependenciesContext.Provider>
  );
};

export const useDependencies = (): Dependencies => {
  const context = useContext(DependenciesContext);
  if (!context) {
    throw new Error('useDependencies must be used within a DependenciesProvider');
  }
  return context;
};